// 🌿 API Craft Back Office - Page Title Hook
import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const baseTitle = 'API Craft';
    document.title = title ? `${title} - ${baseTitle}` : baseTitle;
    
    // Cleanup: reset to base title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [title]);
};

// Export some common page titles as constants
export const PAGE_TITLES = {
  DASHBOARD: 'Dashboard',
  MODELS: 'Models',
  CREATE_MODEL: 'Create Model',
  PROFILE: 'Profile',
  LOGIN: 'Sign In',
  REGISTER: 'Register',
} as const;
